// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1HObq","label":"SetPasswdForm_label__X-oHM"};